import { UserImageContainer } from '@anm/components/SocialAvatar';
import Tooltip from '@anm/components/Tooltip';
import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const DestinationItem = styled.div<{ zIndex: number }>`
  position: relative;
  z-index: ${({ zIndex }) => zIndex};
`;

export const TooltipText = styled.span`
  color: #fff;
  font-size: 14px;
`;

export const DestinationTooltip = styled(Tooltip)`
  min-width: 220px;
  padding: 12px 16px;
  transform: translate(40%, calc(-100% - 10px));
  &:before {
    left: 49%;
  }
`;

const mobileWrapper = media.phone`
  padding-right: 10px;
`;

export const DestinationsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 10px;
  margin-right: auto;
  margin-bottom: 15px;

  ${UserImageContainer} {
    flex-shrink: 0;
    margin-right: -6px;
  }

  ${mobileWrapper};
`;

export const AdditionalSign = styled.div`
  height: 54px;
  ${flexCenter};
  font-size: 16px;
  font-weight: 700;
  color: var(--gray_900);
  margin-left: 25px;
`;
